import { getCookie } from '../../../utils';
import ABTEST from '@huyafed/abtest-config';
declare global {
  interface Window {
    ya: any;
  }
}
const getAb = async () => {
  const useragent = navigator.userAgent;
  const isIOS = !!useragent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  const params = {
    platform: isIOS ? 'ios' : 'adr',
    businessId: 'huya',
    uid: Number(getCookie('udb_uid')),
    guid: getCookie('guid'),
    env: false,
    variable: {
      client_mid: getCookie('__yamid_new'),
    },
  };
  const options = {
    loopTime: 0,
    type: 'web',
  };
  const instance = new ABTEST(params, options);

  const t = instance.getABExtParam();
  window.ya && window.ya.setExtParam('oexp=' + t.mpExperiment);
  const res = await instance.getABExtParam();

  return res.mpConfig.friend_invitation_head;
};
export default getAb;
